const minDate = '01-01-2013'

export default minDate
